import theme from '@ifca-root/react-component/src/assets/theme';
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { advancedFilterList } from '@ifca-root/react-component/src/components/Filter/AdvancedFilter';
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import IconText from '@ifca-root/react-component/src/components/Typography/IconText';
import {
  Avatar,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  useMediaQuery,
} from '@material-ui/core';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PersonIcon from '@material-ui/icons/Person';
import { CardExpansionHeader } from 'components/CardExpansion/CardExpansionHeader';
import { ApprovalLogDialog } from 'components/Dialog/ApprovalLogDialog';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import { RejectDialog } from 'components/Dialog/RejectDialog';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { useColorStatusList } from 'helpers/Hooks/useColorStatusList';
import { useMenuOption } from 'helpers/Hooks/useMenuOption';
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import React, { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory, useLocation, useParams } from 'react-router';
import SubmitterLog from '../../../assets/icons/submitter-log.svg';
import { TooltipAmtFooter } from '../../../components/Footer/TooltipAmtFooter';
import {
  AcctPermission,
  ApprovalStatus,
  useActionOnGrtnStatusMutation,
  useGetApprovalPolicyAssignmentQuery,
  useGetApprovalPolicyQuery,
} from '../../../generated/graphql';
import {
  formatDate,
  formatTime,
} from '../../../helpers/StringNumberFunction/formatDate';
import { GRTNDetailContent } from './GRTNDetail/GRTNDetailContent';
import { GRTNDetailItemContent } from './GRTNDetail/GRTNDetailItemContent';

export const GeneralGRTNPostingList = (props: any) => {
  const {
    list,
    filteredList,
    condition,
    listLoading,
    listStatus,
    postIDs,
    setPostIDs,
    userList,
    loadGRTN,
    setOriginalListing,
    selectedField,
    sortOrder,
  } = props;

  const companyStatus = localStorage?.getItem('companyStatus');
  let history = useHistory();
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'));
  const { CompanyID }: any = useParams();
  let location = useLocation();
  let editData: any = location?.state;
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const { menu, handleClick, handleClose, resetMenu }: any = useMenuOption();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });
  const [openWorkFlow, setWorkFlow] = useState(false);
  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);
  const [errAppDialog, setErrAppDialog] = useState(false);
  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [clickReject, setIsReject] = useState(false);
  const [rejectDialogInput, setRejectDialogInput] = useState({
    RejectionRemark: '',
  });

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any,
  );
  const { handleStatusColor, handleStatusRename } = useColorStatusList();

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    actionOnGRTNStatus,
    { loading: actionGRTNLoading, error: actionGRTNError },
  ] = useActionOnGrtnStatusMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrAppDialog(true);
    },
    onCompleted: data => {
      setSnackBarMsg(SystemMsgs.updateRecord());
      setOpenSnackBar(true);
      setTimeout(() => {
        history.push({
          pathname: `/general-purchase/${CompanyID}/good-return-note`,
          state: { success: true, msgMode: 'update' },
        });
      }, 500);
      setOriginalListing([]);
      loadGRTN({
        variables: {
          CompanyID: CompanyID,
          StatusArr: 'SUBMIT',
          take: 30,
          skip: 0,
          RoleID: user?.roleDetail?.RoleID,
          searchValue:
            getSearch?.name !== '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
          sortField: selectedField === null ? undefined : selectedField,
          sortOrder: sortOrder === null ? undefined : sortOrder,
        },
      });
    },
  });

  const {
    loading: loadingApprovalAssignment,
    data: { getApprovalPolicyAssignment } = { getApprovalPolicyAssignment: [] },
  } = useGetApprovalPolicyAssignmentQuery({
    fetchPolicy: 'network-only',
    variables: {
      Category: 'GP_GRTNHeader',
      CompanyID: CompanyID,
    },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const {
    data: { getApprovalPolicy } = { getApprovalPolicy: [] },
    loading: getApprovalPolicyLoading,
  } = useGetApprovalPolicyQuery({
    variables: { Category: 'GP_GRTNHeader' },
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */
  // handle checkbox for all employee
  const handleSelectAll = e => {
    let temp = postIDs;
    if (e.target.checked) {
      filteredList.map(v => {
        if (!checkboxChecking(v)) temp.add(v?.GRTNHeaderID);
      });
    } else {
      temp.clear();
    }
    setPostIDs(new Set(temp));
  };

  // handle checkbox for specific entityCoa
  const handleCheckBoxChange = (e: any, postID, index: number) => {
    let temp = postIDs;
    if (!temp.has(postID)) {
      temp.add(postID);
    } else {
      temp.delete(postID);
    }

    setPostIDs(new Set(temp));
  };

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker();
  /**ACL */
  /* -------------------------------------------- */
  /*                    SUBMIT                   */
  /* -------------------------------------------- */
  const onSubmit = (listPostIDs, status) => {
    actionOnGRTNStatus({
      variables: {
        GRTNHeaderID: listPostIDs,
        ApprovalStatus: status,
        CompanyID: CompanyID,
        input: {
          RejectionDate: new Date().toISOString(),
          RejectionRemark:
            status === ApprovalStatus.Rejected
              ? rejectDialogInput?.RejectionRemark
              : null,
        },
      },
    });
  };

  useEffect(() => {
    if (clickReject) {
      onSubmit(listPostIDs, ApprovalStatus.Rejected);
    }
  }, [clickReject]);

  useEffect(() => {
    if ((list && list?.length > 0) || list?.length === 0) {
      setOriginalListing(list, v => {
        v['DocDate'] = formatDate(v.DocDate);
      });
    }
  }, [list]);

  const ApprovalPolicyLevel =
    getApprovalPolicyAssignment[0]?.ApprovalList?.length === 0
      ? getApprovalPolicyAssignment
      : getApprovalPolicy;

  const checkboxChecking = el => {
    let finalStatus = false;
    const isSubmitter = workflow => workflow?.SubmitterID === user?.ID;

    if (user?.superUser) {
      if (
        getApprovalPolicy?.length > 0 ||
        getApprovalPolicyAssignment[0]?.ApprovalList?.length > 0
      ) {
        finalStatus = true;
      }
    } else {
      const pendingWorkflows = el?.ApprovalWorkflow?.filter(
        workflow => workflow?.WorkflowStatus === 'PENDING',
      );
      const submitterCheck = pendingWorkflows?.some(isSubmitter);
      if (submitterCheck) {
        finalStatus = true;
      }
    }
    return finalStatus;
  };

  let listPostIDs: any = Array.from(postIDs || []);

  let checkedData = [];
  listPostIDs.map(ID => {
    filteredList.map((el, i) => {
      if (el?.GRTNHeaderID === ID) {
        checkedData.push(...el?.GRTNHeaderItem);
      }
    });
  });

  return (
    <>
      {listLoading && <Loading />}
      {actionGRTNLoading && <Loading />}
      {getApprovalPolicyLoading && <Loading />}
      {loadingApprovalAssignment && <Loading />}
      <ContentWrapper
        style={{ marginTop: isDesktop ? '70px' : '-7px' }}
        overflow
      >
        {listStatus === 'SUBMIT' && filteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              onChange={handleSelectAll}
              color="primary"
              value={''}
              checked={postIDs?.size === filteredList?.length}
              style={{ marginLeft: '-5px', marginTop: '-5px' }}
              disabled={
                filteredList.filter(el => !checkboxChecking(el)).length === 0 ||
                companyStatus === 'INACTIVE' ||
                handlePermDisabled({
                  companyID: CompanyID,
                  permEnum: AcctPermission.GeneralPurchaseGoodReturnNoteApproveReject,
                })
              }
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length;
                loadGRTN({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    RoleID: user?.roleDetail?.RoleID,
                    searchValue:
                      getSearch?.name !== '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                    sortField:
                      selectedField === null ? undefined : selectedField,
                    sortOrder: sortOrder === null ? undefined : sortOrder,
                  },
                });
              }}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)
                // ?.sort((a, b) => {
                //   return a.DocDate.localeCompare(b.DocDate);
                // })
                .map((el, index) => {
                  return (
                    <CardExpansion
                      summary={
                        <ListItem key={index}>
                          {listStatus === 'SUBMIT' ? (
                            <FormControl
                              component="fieldset"
                              style={{ width: '16px', paddingRight: '16px' }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={el?.GRTNHeaderID}
                                    onChange={e => {
                                      handleCheckBoxChange(
                                        e,
                                        el?.GRTNHeaderID,
                                        index,
                                      );
                                    }}
                                    onClick={e => e.stopPropagation()}
                                    checked={postIDs?.has(el?.GRTNHeaderID)}
                                    color="primary"
                                    style={{
                                      marginLeft: '10px',
                                      marginRight: '-5px',
                                      // marginTop: '-15px',
                                    }}
                                    disabled={
                                      companyStatus === 'INACTIVE'
                                        ? true
                                        : false
                                    }
                                  />
                                }
                                label=""
                                name="check"
                                disabled={checkboxChecking(el)}
                              />
                            </FormControl>
                          ) : null}

                          <ListItemText
                            primary={
                              <>
                                <span className="desc date-width">
                                  {`${formatDate(el?.DocDate)}`}
                                </span>
                                <span className="xsTitle flex-space">
                                  {el?.DocNo ?? el?.RefNo}
                                </span>
                                <span className="desc">
                                  {`Trx: ${formatDate(el?.TransactionDate)}`}
                                </span>
                              </>
                            }
                            secondary={
                              <>
                                <Grid spacing={1} container className="table-content">
                                  <Grid item xs={8}>
                                    <div className="icon-text">
                                      <Tooltip
                                        disableFocusListener
                                        title={
                                          <React.Fragment>
                                            <Grid
                                              container
                                              wrap="nowrap"
                                              spacing={2}
                                            >
                                              <Grid item>
                                                <Avatar
                                                  style={{
                                                    width: '20px',
                                                    height: '20px',
                                                  }}
                                                >
                                                  <PersonIcon
                                                    style={{ fontSize: 'small' }}
                                                  />
                                                </Avatar>
                                              </Grid>
                                              <Grid item xs zeroMinWidth>
                                                <div style={{ fontSize: '12px' }}>
                                                  {userList?.find(
                                                    x => x?.ID === el?.createdBy,
                                                  )?.name ??
                                                    userList?.find(
                                                      x =>
                                                        x?.ID === el?.createdBy ??
                                                        el?.modBy,
                                                    )?.name}
                                                </div>
                                                <div style={{ fontSize: '10px' }}>
                                                  {formatDate(
                                                    el?.modTs ?? el?.createdTs,
                                                  )}
                                                  &nbsp;
                                                  {formatTime(
                                                    el?.modTs ?? el?.createdTs,
                                                  )}
                                                </div>
                                              </Grid>
                                            </Grid>
                                          </React.Fragment>
                                        }
                                        arrow
                                        enterTouchDelay={0}
                                      >
                                        <div>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          ></IconText>
                                        </div>
                                      </Tooltip>

                                      <span
                                        className="desc flex-space"
                                        style={{ display: 'contents' }}
                                      >
                                        {el?.Supplier?.CompanyName}
                                      </span>
                                    </div>
                                  </Grid>
                                
                                  <Grid
                                    item
                                    xs={4}
                                    container
                                    justifyContent="flex-end"
                                    alignItems="center"
                                  >
                                    <span className="desc">
                                      <IconButton
                                        style={{
                                          padding: '0px',
                                          paddingRight: '5px',
                                        }}
                                        className="desc"
                                        onClick={e => {
                                          handleClick(
                                            e,
                                            el?.GRTNHeaderID,
                                            index,
                                            el,
                                          );
                                          setWorkFlow(true);
                                        }}
                                      >
                                        <ListAltIcon
                                          style={{ fontSize: '13px' }}
                                        />
                                      </IconButton>
                                    </span>
                                    <span
                                      className="desc"
                                      style={{
                                        color: `${handleStatusColor(
                                          el?.ApprovalStatus,
                                        )}`,
                                      }}
                                    >
                                      {handleStatusRename(el?.ApprovalStatus)}
                                    </span>
                                  </Grid>
                                </Grid>
                              </>
                            }
                          />
                        </ListItem>
                      }
                    >
                      {/* {el?.GRTNHeaderItem?.length > 0 && (
                      <GRTNContent mode="submit" dataDetail={el} />
                    )} */}
                      {
                        <>
                          <GRTNDetailContent
                            listEl={el}
                            documentListing={el?.Attachment}
                            listStatus={'SUBMIT'}
                            userList={userList}
                            mode={'expansion'}
                          />
                          <CardExpansionHeader title={'GRTN Detail'} />
                          <GRTNDetailItemContent
                            listItem={el?.GRTNHeaderItem}
                          />
                        </>
                      }
                    </CardExpansion>
                  );
                })}
            </InfiniteScroll>
          )}
        </List>
        <div style={{ marginBottom: '100px' }}></div>
      </ContentWrapper>

      {user?.superUser &&
      ApprovalPolicyLevel[0]?.ApprovalList.length > 0 ? null : (
        <TooltipAmtFooter data={checkedData} module={'grtn-submit'} />
      )}

      {user?.superUser &&
      ApprovalPolicyLevel[0]?.ApprovalList.length > 0 ? null : (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => {
                setOpenRejectDialog(true);
                // onSubmit(listPostIDs, ApprovalStatus.Active);
              },
              color: 'secondary',
              props: {
                disabled:
                postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum: AcctPermission.GeneralPurchaseGoodReturnNoteApproveReject,
                  }),
              },
            },
            {
              name: 'Approve',
              onClick: () => {
                onSubmit(listPostIDs, ApprovalStatus.Completed);
              },
              color: 'primary',
              props: {
                disabled:
                postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum: AcctPermission.GeneralPurchaseGoodReturnNoteApproveReject,
                  }),
              },
            },
          ]}
        />
      )}

      <RejectDialog
        data={filteredList}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />

      <ApprovalLogDialog
        data={menu}
        setWorkFlow={setWorkFlow}
        openWorkFlow={openWorkFlow}
        moduleName="Goods Return Note"
        reset={resetMenu}
        handleClose={() => handleClose()}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />

      <ErrorDialog
        errorDia={errAppDialog}
        setErrorDia={setErrAppDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
        isBool
        onclick={() => {
          setErrAppDialog(false);
          window.location.reload();
        }}
      />
    </>
  );
};
